(() => {
    "use strict";
    var t = {
            d: (e, s) => {
                for (var o in s) t.o(s, o) && !t.o(e, o) && Object.defineProperty(e, o, {
                    enumerable: !0,
                    get: s[o]
                })
            },
            o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
            r: t => {
                "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(t, "__esModule", {
                    value: !0
                })
            }
        },
        e = {};
    t.r(e), t.d(e, {
        LoyaltyLionUtil: () => LoyaltyLionUtil
    });
    class TrapFocusLite {
        constructor(t) {
            this.ObserverLite = new ObserverLite, this.element = t, this.element.addEventListener("keydown", (t => {
                this.keyDownHandler(t)
            }))
        }
        subscribe(t) {
            return this.ObserverLite.subscribe(t)
        }
        next(t) {
            this.ObserverLite.next(t)
        }
        setAttributes(t, e) {
            for (let s in e) t.setAttribute(s, e[s])
        }
        removeAttributes(t, e) {
            e.forEach((e => {
                t.removeAttribute(e)
            }))
        }
        get focusables() {
            return this.element.querySelectorAll('summary, [tabindex="0"], [role="button"], a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])')
        }
        setFocus() {
            this.lastFocusedElement = document.activeElement, this.focusables[0]?.focus()
        }
        resetFocus() {
            this.lastFocusedElement.focus()
        }
        keyDownHandler(t) {
            const e = this.focusables,
                s = e[0],
                o = e[e.length - 1];
            "Tab" === t.key || 9 === t.keyCode ? t.shiftKey ? document.activeElement === s && (t.preventDefault(), o.focus()) : document.activeElement === o && (t.preventDefault(), s.focus()) : this.next({
                key: t.key
            })
        }
    }
    class ModalBox {
        constructor({
            content: t,
            settings: e
        }) {
            window.ModalBoxInstance && window.ModalBoxInstance.close(), window.ModalBoxInstance = this, this.content = t, this.settings = e || {
                containerCloseButton: !0
            }, this.ObserverLite = new ObserverLite
        }
        subscribe(t) {
            return this.ObserverLite.subscribe(t)
        }
        next(t) {
            this.ObserverLite.next(t)
        }
        toggle() {
            this.active ? this.close() : this.open()
        }
        open() {
            return this.active = !0, this.next({
                type: "open"
            }), new Promise(((t, e) => {
                if (!this.wrapper) {
                    let t = `<div class="modal-wrapper ${this.settings.wrapperClass?this.settings.wrapperClass:""}"\n                            style="${this.settings.wrapperStyles?this.settings.wrapperStyles:""}">\n                         <div class="modal-mask modal-close"></div>\n                         <div class="modal-flex ${this.settings.flexClass?this.settings.flexClass:""}">\n                           <div class="modal-content  \n                                       ${this.settings.contentClass?`${this.settings.contentClass}`:""}\n                                       ${this.settings.overlayClose?"modal-close":""}">\n                              ${this.settings.containerCloseButton?'<button aria-label="close" class="modal-close modal-close-btn btn-reset"></button>':""}\n                           </div>\n                         </div>\n                       </div>`;
                    t = parseHTML(t), this.wrapper = t.querySelector(".modal-wrapper"), this.wrapper.style.opacity = 0, this.mask = t.querySelector(".modal-mask"), this.content = parseHTML(this.content), this.contentWrapper = t.querySelector(".modal-content"), this.contentWrapper.style.opacity = 0, this.contentWrapper.appendChild(this.content), t.querySelectorAll(".modal-close").forEach((t => {
                        t.addEventListener("click", (t => {
                            t.preventDefault(), this.close()
                        }))
                    })), document.body.appendChild(t), this.TrapFocusLite = new TrapFocusLite(this.wrapper), this.TrapFocusLite.subscribe((({
                        key: t
                    }) => {
                        "Escape" == t && this.close()
                    }))
                }
                window.innerWidth, document.body.clientWidth;
                document.body.classList.add("body-masked"), this.wrapper.style.display = "block", this.wrapper.animate([{
                    opacity: 0
                }, {
                    opacity: 1
                }], 300).onfinish = t => {
                    t.target.effect.target.style.opacity = 1
                }, this.contentWrapper.animate([{
                    transform: "translateY(100px)",
                    opacity: 0
                }, {
                    transform: "translateY(0px)",
                    opacity: 1
                }], 300).onfinish = e => {
                    e.target.effect.target.style.transform = "translateY(0px)", e.target.effect.target.style.opacity = 1, this.TrapFocusLite.setFocus(), this.TrapFocusLite.setAttributes(this.wrapper, {
                        role: "dialog",
                        "aria-modal": "true",
                        "aria-live": "assertive"
                    }), this.TrapFocusLite.removeAttributes(this.wrapper, ["aria-hidden"]), this.next({
                        type: "open:rendered"
                    }), t()
                }
            }))
        }
        close() {
            this.active = !1, this.next({
                type: "close"
            }), this.wrapper.animate([{
                opacity: 1
            }, {
                opacity: 0
            }], 200).onfinish = t => {
                t.target.effect.target.style.opacity = 0, document.body.classList.remove("body-masked"), document.body.style.paddingRight = "0px", this.wrapper.style.display = "none"
            }, this.contentWrapper.animate([{
                transform: "scale(1)",
                opacity: 1
            }, {
                transform: "scale(1.2)",
                opacity: 0
            }], 200).onfinish = t => {
                t.target.effect.target.style.opacity = 0, this.TrapFocusLite.resetFocus(), this.TrapFocusLite.removeAttributes(this.wrapper, ["role", "aria-modal", "aria-live"]), this.TrapFocusLite.setAttributes(this.wrapper, {
                    "aria-hidden": "true"
                }), this.next({
                    type: "close:finish"
                })
            }
        }
        destroy() {
            this.wrapper.remove()
        }
    }
    class LoyaltyLionUtil {
        constructor(t) {
            return window.LoyaltyLionUtilObserver$ = window.LoyaltyLionUtilObserver$ || new ObserverLite, new Promise(((e, s) => {
                window.LoyaltyLionUtilSingleton ? window.LoyaltyLionUtilObserver$.loaded ? e(window.LoyaltyLionUtilSingleton) : window.LoyaltyLionUtilObserver$.subscribe((() => {
                    e(window.LoyaltyLionUtilSingleton)
                })) : t ? (window.LoyaltyLionUtilSingleton = this, this.settings = t, this.ObserverLite = new ObserverLite, this.subscribe((() => {
                    window.LoyaltyLionUtilObserver$.loaded = !0, window.LoyaltyLionUtilObserver$.next()
                })), this.loadAPIPromise().then((() => {
                    window.loyaltylion._customer = window.loyaltylion.customer, this.loyaltylion = window.loyaltylion, e(window.LoyaltyLionUtilSingleton), this.next()
                }))) : window.LoyaltyLionUtilObserver$.subscribe((() => {
                    e(window.LoyaltyLionUtilSingleton)
                }))
            }))
        }
        subscribe(t) {
            return this.ObserverLite.subscribe(t)
        }
        next(t) {
            this.ObserverLite.next(t)
        }
        loadAPIPromise() {
            return new Promise(((t, e) => {
                window.loyaltylion.ui ? t() : window.loyaltylion.on("ready", (() => {
                    t()
                }))
            }))
        }
        get rewards() {
            const {
                program: t,
                _customer: e
            } = this.loyaltylion;
            let s = JSON.parse(JSON.stringify(t.rewards)).filter((({
                discount_type: t,
                kind: e
            }) => "flat" == t && "cart_discount_voucher" == e));
            if (s.unshift({
                    discount_amount: 0,
                    point_cost: 0
                }), s = s.map((t => (t.point_cost = 10 * t.discount_amount, t.active = !!e && e.pointsRedeemable >= t.point_cost, t))).sort(((t, e) => t.point_cost - e.point_cost)), e) {
                const t = s.filter((({
                    active: t
                }) => t)).length - 1;
                t >= 0 && (s[t].current = !0)
            }
            return s
        }
        addOneYearToDate(t) {
            const e = new Date(t);
            e.setFullYear(e.getFullYear() + 1);
            return `${e.getDate().toString().padStart(2,"0")}/${(e.getMonth()+1).toString().padStart(2,"0")}/${e.getFullYear()}`
        }
        showReward(t) {
            t = parseInt(t);
            const e = this.loyaltylion.customer.claimedRewards.find((({
                id: e
            }) => e == t));
            const s = new ModalBox({
                content: `\n        <div class="ll-modal-content tac bg-white flex flex-grid column-nowrap align-center justify-center">\n          <h2 class="h-style h-style--accent t-xl">¿Tienes tu código?</h2>\n          <div class="rte-content lh-r t-m">\n            <p>Copie el código haciendo clic en el botón de abajo. Puede consultar sus vales de recompensa en cualquier momento en la sección «Sus premios disponibles» de esta página. </p>\n          </div>\n          <div class="ll-modal-content__code">${e.redeemable.code}</div>\n          <button data-code="${e.redeemable.code}"\n                  class="js-copy-code-btn btn btn--large">Copiar Código</button>\n        </div>\n      `
            });
            s.subscribe((({
                type: t
            }) => {
                "open:rendered" == t && s.wrapper.querySelector(".js-copy-code-btn").addEventListener("click", (t => {
                    t.preventDefault();
                    const e = t.currentTarget,
                        s = e.innerText;
                    e.innerText = "Copied", navigator.clipboard.writeText(e.dataset.code), setTimeout((() => {
                        e.innerText = s
                    }), 2e3)
                }))
            })), s.open()
        }
        claimReward(t) {
            return new Promise(((e, s) => {
                t = parseInt(t);
                const o = this.loyaltylion.program.rewards.find((({
                    id: e
                }) => e == t));
                console.log("reward", o);
                let n = "¿Cambiar {{points}} puntos por este vale de recompensa? Le recomendamos que convierta sus puntos en un vale de recompensa una vez que esté listo para realizar una compra.";
                n = n.replace("{{points}}", o.point_cost);
                let i = "{{min_spend}} gasto mínimo una vez aplicado el vale de recompensa";
                i = i.replace("{{min_spend}}", `${this.settings.currencySymbol}${o.minimum_spend-o.discount_amount}`);
                const r = new ModalBox({
                    content: `\n          <div class="ll-modal-content tac bg-white flex flex-grid column-nowrap align-center justify-center">\n            <h2 class="h-style h-style--accent t-xl">${o.title}</h2>\n            <div class="rte-content lh-r t-m">\n              <p>${n}</p>\n              <p class="t-s">${i}</p>\n            </div>\n            <button class="js-confirm-claim-btn btn btn--large">Canjear Puntos</button>\n          </div>\n        `
                });
                r.subscribe((({
                    type: o
                }) => {
                    "open:rendered" == o && r.wrapper.querySelector(".js-confirm-claim-btn").addEventListener("click", (o => {
                        o.preventDefault(), o.currentTarget.classList.add("btn--loading");
                        const {
                            api: n
                        } = this.loyaltylion, i = {
                            method: "POST",
                            headers: {
                                ...n.http.headers,
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                reward_id: t
                            })
                        };
                        fetch(`${n.http.baseUrl}/customers/rewards/claim`, i).then((t => t.json())).then((t => {
                            const {
                                action: s,
                                claimed_reward: o
                            } = t, {
                                pointsApproved: n,
                                pointsTotal: i,
                                pointsSpent: r
                            } = t.customer;
                            this.loyaltylion._customer.actions.unshift(s), this.loyaltylion._customer.claimedRewards.unshift(o), this.loyaltylion._customer = {
                                ...this.loyaltylion.customer,
                                pointsRedeemable: n,
                                pointsTotal: i,
                                pointsSpent: r
                            }, e(o), this.next()
                        })).catch((t => {
                            console.log(t), s(t)
                        }))
                    })), "close:finish" == o && r.destroy()
                })), r.open()
            }))
        }
    }
    var s = self;
    for (var o in e) s[o] = e[o];
    e.__esModule && Object.defineProperty(s, "__esModule", {
        value: !0
    })
})();